module.exports = __webpack_public_path__ + "static/img/xqhz_7.94627f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xqhz/xqhz_7.png
// module id = Zy81
// module chunks = 181